





















































































































































































































































import { sha256, sha224 } from 'js-sha256';
import {AttachmentApi} from "@/repository/AttachmentApi";
import VueFramework from 'vue'
import UploadFilesComponent from '../components/wiki/UploadFilesComponent.vue';
import ChannelComponent from '../components/wiki/ChannelComponent.vue';
import TopicComponent from '../components/wiki/TopicComponent.vue';
import CreateChannelModal from '../components/wiki/CreateChannelModal.vue';
import DeleteChannelModal from '../components/wiki/DeleteChannelModal.vue';
import DeletePostModal from '../components/wiki/DeletePostModal.vue';
import EditPost from '../components/wiki/EditPost.vue';
import DeleteTopicModal from '../components/wiki/DeleteTopicModal.vue';
import {Component, Vue, Watch} from 'vue-property-decorator';
import * as topicRecord from "@/store/Topic/TopicRecord";
import * as auth from "@/store/authenticate";
import LayoutDefault from '../../layout/default.vue';
import ChannelApi from '../repository/ChannelApi';
import '@progress/kendo-ui'
import '@progress/kendo-theme-default/dist/all.css'

import { Editor } from '@progress/kendo-editor-vue-wrapper'
import { EditorTool } from '@progress/kendo-editor-vue-wrapper'
import { EditorInstaller } from '@progress/kendo-editor-vue-wrapper'

import * as dtos from '../repository/messagehub.dtos';
import {AxiosError, AxiosResponse} from "axios";
import {
    AttachmentSummary,
    Channel,
    CreateAttachment,
    CreateAttachmentResponse,
    CreateOrUpdateTopicResponse,
    CreatePost,
    CreateTopic,
    EntityInformation,
    EntityType,
    FileUploadList,
    FinalizeAttachmentUpload,
    FinalizeAttachmentUploadResponse,
    GetAttachment, GetAttachmentResponse,
    GetChannelsResponse,
    Post,
    Topic,
    UpdatePost,
    UpdateTopic
} from "../repository/messagehub.dtos";
import UploadButton from '../../node_modules/vuetify-upload-button/src/UploadButton.vue';
import {TopicApi} from "../repository/TopicApi";
import {PostsApi} from "../repository/PostsApi";
import * as channelRecord from "../store/Channel/ChannelRecord";
import * as postRecord from "../store/Posts/PostRecord"
VueFramework.use(EditorInstaller)


@Component({
    components: {
        CreateChannelModal,
        DeleteChannelModal,
        DeleteTopicModal,
        DeletePostModal,
        EditPost,
        UploadButton,
        UploadFilesComponent,
        ChannelComponent,
        TopicComponent
    },
    name: 'Wiki'
})
export default class Wiki extends Vue {
    fileUploadList: FileUploadList[] = []
    maxFileSize: number = 52428800
    isFileBeingUploaded: boolean= false
    //topic
    isDeleteTopicModalVisible: boolean = false
    topicApi: TopicApi = new TopicApi()
    topicContentWarning: boolean = false
    topicTitle: string = ''
    htmlText:string = ""
    topicErrrorContent: string = ''
    //end Topic\
    //channel start
    isDeleteModalVisible: boolean = false;
    //channel end

    //posts start
    isPostEditorVisible: boolean = false
    postsApi: PostsApi = new PostsApi()
    isPostCreatorVisible: boolean = false
    isDeletePostModalVisible: boolean = false


    //posts end

    //utils
    reader= (file: File) => new Promise((resolve:any, reject:any) => {
        const reader = new FileReader();
        reader.onload = () => <ArrayBuffer>resolve(reader.result);
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);  // or a different mode
    });

    checkFileSize(file: File){
        if (file ==null || file.size > this.maxFileSize){
            console.log('maximum file size or file null')
            return false
        }
        return true
    }
    async postEditorFocusOut(){
        await this.onCreatePost(false)
    }
    async fileChanged(list: FileList){
        this.isFileBeingUploaded = true
        this.fileUploadList = []
        for (let x = 0; x < list.length; x++) {
            let e:File = list[x]
            this.fileUploadList.push(new FileUploadList(e.name, 0))
        }
        for (let x = 0; x < list.length; x++) {
            if (this.checkFileSize(list[x])){
                let e:File | null = list[x]
                let fileArray: ArrayBuffer =<ArrayBuffer> await this.reader(e)
                let hash = sha256(fileArray)
                let entityInfo = new EntityInformation(this.selectedPost.id, EntityType.Post); ///POST HAS NO ID AS POST BEING WRITTEN
                let payload = new CreateAttachment(e.name, e.name, false, e.type, hash, e.size, entityInfo)

                let json = JSON.stringify(payload)
                let createAttachment:AxiosResponse = await this.axios.post('https://api.messagehub.ca/attachment', json, {
                    withCredentials: true,
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    }
                })
                if (createAttachment.status != 200){
                    this.isFileBeingUploaded = true
                    return;
                }
                let createAttachmentResponseData: CreateAttachmentResponse = createAttachment.data
                let putHeadersDictionary = createAttachmentResponseData.latestAttachmentVersion.putHeaders
                let putUrl = createAttachmentResponseData.latestAttachmentVersion.putUrl
                let putHeaders:any = {};

                for (let x = 0; x < putHeadersDictionary.length; x++) {
                    putHeaders[putHeadersDictionary[x].name] = putHeadersDictionary[x].value;
                }

                try {
                    let fileUploadResult:AxiosResponse = await this.axios.put(putUrl, fileArray, {
                        headers: putHeaders,
                        withCredentials: false,
                        onUploadProgress: progressEvent => {
                            this.fileUploadList[x].percentageCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total )
                        }

                    })
                    if (fileUploadResult.status == 200){
                        let finalizeFileUpladData = new FinalizeAttachmentUpload(createAttachmentResponseData.id,
                            fileUploadResult.headers['x-amz-version-id'],true,
                            createAttachmentResponseData.latestAttachmentVersion.id,
                            fileUploadResult.headers['date'])
                        let json = JSON.stringify(finalizeFileUpladData)
                        let finalizeFileUploadDataRequest:AxiosResponse = await this.axios.patch('https://api.messagehub.ca/attachment', json,{
                            withCredentials: true,
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                            }
                        })
                        if (finalizeFileUploadDataRequest.status==200){
                            let updatePost = this.selectedPost
                            let data: FinalizeAttachmentUploadResponse = finalizeFileUploadDataRequest.data
                            if (updatePost.attachments){
                                updatePost.attachments.push(new AttachmentSummary(data.id, data.name))
                            }
                            else{
                                updatePost.attachments = []
                                updatePost.attachments.push(new AttachmentSummary(data.id, data.name))
                            }
                            postRecord.updatePost(this.$store, updatePost)
                        }

                    };

                }
                catch(e){
                    console.log(e)
                }
            }
        }
        this.isFileBeingUploaded = false
    }
    attachmentApi: AttachmentApi = new AttachmentApi()
    async downloadFile(attachment: AttachmentSummary){
        let data = new GetAttachment(attachment.id)
        let result:AxiosResponse = await this.attachmentApi.getDownloadUrl(data);
        let downloadUrlData: GetAttachmentResponse = result.data
        let downloadUrl = downloadUrlData.downloadUrl;
        let downloadData = await this.axios.get(downloadUrl, {responseType: 'blob', withCredentials: false})
        let blob = new Blob([downloadData.data], { type: 'application/octet-stream' })
        let link: any = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        //link.href = downloadUrl
        link.download = attachment.name
        link.click()
    }
    parseDate (jsonDateString: string): string{
        return new Date(parseInt(jsonDateString.replace('/Date(', ''))).toLocaleDateString()
    }
    onShowPostCreatorEvent(event:any){
        this.isPostCreatorVisible = event
    }
    showDeleteChannelModal(){
        this.isDeleteModalVisible = true;
    }
    //initialize
    data () {
        return {

            topicMenu: [
                {
                    id: 0,
                    description: "Edit Topic"
                },
                {
                    id: 1,
                    description: "Delete Topic"
                }
            ],
            postMenu: [
                {
                    id: 0,
                    description: "Edit Post"
                },
                {
                    id: 1,
                    description: "Delete Post"
                }
            ],
            createChannelDialog: false,

        }
    }
    created() {

        this.$emit('update:layout', LayoutDefault);
    }

    //channel


    channelDeletedEvent(response:AxiosResponse){
        this.isDeleteModalVisible = false
        if (response.status == 204){
            topicRecord.selectedTopicChanged(this.$store, null)
            topicRecord.initializeTopics(this.$store, [])
            postRecord.initializePosts(this.$store, []);
            channelRecord.deleteChannel(this.$store, <Channel> this.selectedChannel)

        }
    }


    get selectedChannel(){
        return channelRecord.getSelectedChannel(this.$store)
    }
  //topic

    async onUpdateTopic(){
        let editor:any = this.$refs.topicEditor;
        let widget = editor.kendoWidget()
        const editorText: string = widget.value()


        if (!this.selectedTopic.title || this.selectedTopic.title.trim().length==0){
            this.topicErrrorContent = "Topic title cannot be blank"
            this.topicContentWarning = true
            return
        }
        if (!editorText || editorText.trim().length==0){
            this.topicErrrorContent = "Content cannot be blank"
            this.topicContentWarning = true
            return
        }

        this.topicContentWarning = false;
        const requestBody:UpdateTopic = new UpdateTopic(false, this.selectedTopic.id, this.selectedTopic.title, editorText)

        try {

            let response: AxiosResponse = await this.topicApi.updateTopic(requestBody)
            if (response.status === 200){
                let updatedTopic: CreateOrUpdateTopicResponse = response.data;
                if (this.selectedTopic !=null){
                    let newTopic:Topic = this.selectedTopic
                    newTopic.isDraft = false
                    newTopic.content = updatedTopic.data.content
                    topicRecord.updateTopic(this.$store, newTopic)
                }
            }
        }
        catch (e) {
            console.log(e)
        }

    }

    get topics(){
        return topicRecord.getTopics(this.$store)
    }
    get selectedTopic(){
        return topicRecord.getSelectedTopic(this.$store)

    }
    async topicDeletedEvent(response:any){
        if (response.status == 204){
            topicRecord.deleteTopic(this.$store, this.selectedTopic)
            this.isDeleteTopicModalVisible = false
        }
    }
    async onTopicMenuCommandClick(item:any){
        if (item.id ==0){
            this.selectedTopic.isDraft = true
            this.$nextTick(function () {
                let editor:any = this.$refs.topicEditor;
                let widget = editor.kendoWidget()
                widget.value(this.selectedTopic.content)
            })
        }
        else if (item.id ==1){
            this.isDeleteTopicModalVisible = true
        }
    }

    //posts
    onPostMenuCommandClick(command:any, item:Post){
        if (command.id ==0){
            this.isPostEditorVisible = true
        }
        else if (command.id ==1){
            postRecord.selectedPostChanged(this.$store, item)
            this.isDeletePostModalVisible = true
        }
    }
    updatePostEvent(item:AxiosResponse){
        if (item.status == 200){
            this.$nextTick(function () {
                this.isPostEditorVisible = false
                postRecord.updatePost(this.$store, <Post>item.data.data)
            })
        }
    }
    async onInitializePostEditor(){
        await this.createDraftPost()
        this.isPostCreatorVisible = true
        this.$nextTick(function () {
            let editor:any = this.$refs.postEditor;
            let widget = editor.kendoWidget()
            widget.focus()
        })
    }
    async createDraftPost(){
        const requestBody = new CreatePost("", this.selectedTopic.id, this.selectedChannel.id)
        try {

            let response = await this.postsApi.createPost(requestBody)
            if (response.status === 200){
                postRecord.addPost(this.$store, <Post>response.data.data)
            }
        }
        catch (e) {
            console.log(e)
        }
    }
    async onCreatePost(closePostEditor:boolean = true){
        let editor:any = this.$refs.postEditor;
        let widget = editor.kendoWidget()
        let content = widget.value()
        let post = new UpdatePost(this.selectedPost.id, content)
        let result = await this.postsApi.updatePost(post)
        if (result.status == 200){
            if (closePostEditor){
                this.isPostCreatorVisible = false
            }
            postRecord.updatePost(this.$store, <Post> result.data.data)
        }

    }
    get posts(){
        return postRecord.getPosts(this.$store)
    }
    get selectedPost(){
        return postRecord.getSelectedPosts(this.$store)
    }
    async onCancelCreationOfPost(){
        let result: AxiosResponse = await this.postsApi.deletePost(this.selectedPost.id);
        this.isPostCreatorVisible = false
        if (result.status == 204){
            postRecord.deletePost(this.$store, this.selectedPost)
        }
    }
    onPostEditorBind(e:any){
        if (e.name == "createlink") {
            let kendoJ: any = kendo;
            setTimeout(function() {
                kendoJ.jQuery("#k-editor-link-target").prop("checked", true);
                kendoJ.jQuery("#k-editor-link-target").prop("disabled", true);
            }, 1);
        }
    }
    postDeletedEvent(){
        this.isDeletePostModalVisible = false
    }


}

